const main = () => {
    if (document.querySelector('.l-hamburger') === null) return;

    const toggles = document.querySelectorAll('.js-drawer-toggle');
    const opener = document.querySelector('.l-header__menu');
    const closeBtn = document.querySelector('.l-hamburger__close');
    const setExpanded = (active) => {
        toggles.forEach((btn) => btn.setAttribute('aria-expanded', active ? 'true' : 'false'));
    };
    // 開いたら閉じるボタンへ、閉じたら開くボタンへフォーカスを戻す
    const moveFocus = (active) => {
        if (active) {
            if (closeBtn) closeBtn.focus();
        } else if (opener) {
            opener.focus();
        }
    };

    document.querySelectorAll('[data-open-hamburger]').forEach((element) => {
        element.addEventListener('click', (e) => {
            // アンカーリンク（ページ内遷移）は既定のスクロールを活かしつつドロワーを閉じる
            const isAnchor = element.tagName === 'A';
            if (!isAnchor) e.preventDefault();
            const active = document.body.toggleAttribute('data-menu-active');
            setExpanded(active);
            // アンカー遷移時はスクロールを妨げないためフォーカス移動しない
            if (!isAnchor) moveFocus(active);
        });
    });

    // Esc キーで閉じる
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && document.body.hasAttribute('data-menu-active')) {
            document.body.removeAttribute('data-menu-active');
            setExpanded(false);
            moveFocus(false);
        }
    });
};

export default main;
